import { render, staticRenderFns } from "./shop-subscriptions.vue?vue&type=template&id=34c8db91"
import script from "./shop-subscriptions.component.js?vue&type=script&lang=js&external"
export * from "./shop-subscriptions.component.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDataTable,VSpacer})
